export type Bonus = {
  number: number;
  title: string;
  value: number;
  image: string;
  color: string;
  intro: string;
  listLabel: string;
  list: string[];
  closing: string;
};

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'The Pediatric Praxis Intake & Interview Guide™',
    value: 37,
    image: 'https://cdn.magicpatterns.com/uploads/az8zBnmuYMLrgs7xenNXP3/BONUS_1_PRAXIS-EN.png',
    color: '#2a64c5',
    intro:
      'The questions you ask at the beginning of a case can influence the information you have available later. This guide helps you organize the information that may be relevant when exploring a child’s motor planning and functional participation difficulties.',
    listLabel: 'Structured question sets covering:',
    list: [
      'The family’s primary concerns.',
      'Daily routines and meaningful activities.',
      'Difficulties with unfamiliar activities.',
      'Experiences with imitation and movement sequences.',
      'Activities the child performs more easily or with greater difficulty.',
      'Environmental and contextual differences.',
      'Previous opportunities to learn the activity.',
      'Questions that may require further observation.',
    ],
    closing: 'It also helps you distinguish between information reported by families and performance directly observed during an activity.',
  },
  {
    number: 2,
    title: 'The 15-Minute Motor Planning Case Organizer™',
    value: 37,
    image: 'https://cdn.magicpatterns.com/uploads/mae3FWtnU2P2eJwB2N2twb/BONUS_2_PRAXIS-EN.png',
    color: '#e8664f',
    intro:
      'When information is scattered across different notes, even a familiar case can feel difficult to organize. This printable worksheet brings the main elements together in one place.',
    listLabel: 'It includes:',
    list: [
      'A functional concern summary.',
      'A task demands worksheet.',
      'A motor observation and context matrix.',
      'A missing information filter.',
      'A working hypothesis organizer.',
      'An alternative explanation checklist.',
      'A next-question planning sheet.',
    ],
    closing: 'The timeframe refers to organizing a case summary, not completing a clinical assessment or reaching a diagnostic conclusion.',
  },
  {
    number: 3,
    title: 'The Praxis & Motor Planning Visual Reference Guide™',
    value: 27,
    image: 'https://cdn.magicpatterns.com/uploads/wEP2tX9JQSw2eT21aeE3tt/BONUS_3_PRAXIS-EN.png',
    color: '#2fa37a',
    intro:
      'Sometimes, you don’t need to read an entire chapter to clarify a concept. You need a practical reference that helps you remember what to consider.',
    listLabel: 'Concise visual references on:',
    list: [
      'Praxis and motor planning.',
      'Motor imitation.',
      'Action sequencing.',
      'Task demands.',
      'Familiar versus unfamiliar activities.',
      'Observable motor performance.',
      'Functional participation.',
      'Contextual influences.',
      'Working hypotheses.',
      'Alternative explanations.',
    ],
    closing: 'Designed as an educational reference, not a diagnostic classification system. Keep it nearby while organizing your observations.',
  },
  {
    number: 4,
    title: '10 Pediatric Praxis Case Reasoning Challenges™',
    value: 29,
    image: 'https://cdn.magicpatterns.com/uploads/dsMpvybFKVVbUiCw8mGQXB/BONUS_4_PRAXIS-EN.png',
    color: '#8a5cd1',
    intro:
      'The best way to become familiar with a reasoning framework is to practice using it. Ten fictional educational scenarios, each with a different functional concern, task, or pattern of observed motor performance.',
    listLabel: 'For every case, you’ll explore:',
    list: [
      'What do you actually observe?',
      'What are the demands of the activity?',
      'What information is currently available?',
      'What information is missing?',
      'Which contextual factors deserve consideration?',
      'What alternative explanations might be relevant?',
      'What additional observations could clarify the situation?',
      'What functional impact should you explore?',
      'Which questions could you investigate next?',
    ],
    closing: 'Each challenge includes reflection prompts and an educational review guide — to practice organizing your thinking, not memorize one answer.',
  },
  {
    number: 5,
    title: 'The Functional Motor Goals & Progress Tracker™',
    value: 17,
    image: 'https://cdn.magicpatterns.com/uploads/6azD5th8JvjFhCuJwp8Z2n/BONUS_5_PRAXIS-EN.png',
    color: '#d9940f',
    intro:
      'Once you’ve organized a case, you also need a way to document meaningful functional information over time.',
    listLabel: 'Printable tools to organize:',
    list: [
      'Functional participation priorities.',
      'Baseline performance.',
      'Activity-specific goals.',
      'Observable changes.',
      'Task conditions and levels of support.',
      'Progress review.',
      'Session observations.',
      'Family communication.',
      'Goal revision.',
    ],
    closing: 'Supports clearer documentation of functional progress, without automatically attributing every change to motor planning or praxis.',
  },
];
